import DynamicTable from '../../../components/tables/dynamicTable';
import { getDynamicSelectData } from '../../../utils/api/data';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import React, { useEffect, useState } from 'react';
import { config } from "../../../config/Constants";
import Axios from 'axios';
import Cookies from 'js-cookie';
import './serviceLevel.css';

const ServiceLevel = () => {
  const [reportData, setReportData] = useState([]);
  const [reportData2, setReportData2] = useState([]);
  const [reportData3, setReportData3] = useState([]);

  const getReportData = async() => {
    if (Cookies.get('cp-cn') !== 'GTMS-CP') {
      const response = await getDynamicSelectData({
        selectValues: '"Carrier", "Type", "Net charge","Number of packages","% of spend"', 
        tableName: 'REPORT.SERVICE_LEVEL_BY_TYPE',
        whereField: ["Customer"], 
        whereOperators:["="], 
        whereValue: [Cookies.get('cp-cn')], 
        db: 'SF'
      });
      setReportData({data: response, size: 'small'})
    }
    if (Cookies.get('cp-cn') === 'GTMS-CP') {
      const response = await Axios.get(config.url.GET_REPORT, {
      params: {
        reportName: "servicelevel_type",
        companyName: Cookies.get("cp-cn"),
      },
    });
      setReportData({data: response.data.report})
    };
  }

  const getReportData2 = async() => {
    if (Cookies.get('cp-cn') !== 'GTMS-CP') {
      const response = await getDynamicSelectData({
        selectValues: '"Mode", "Currency", "Net Charge","Number of Packages","% of Spend"', 
        tableName: 'REPORT.SERVICE_LEVEL_BY_MODE',
        whereField: ["Customer"], 
        whereOperators:["="], 
        whereValue: [Cookies.get('cp-cn')], 
        db: 'SF'
      });
      setReportData2({data: response, size: 'small'})
    }
    if (Cookies.get('cp-cn') === 'GTMS-CP') {
      const response = await Axios.get(config.url.GET_REPORT, {
      params: {
        reportName: "servicelevel_mode",
        companyName: Cookies.get("cp-cn"),
      },
    });
      setReportData2({data: response.data.report})
    };
  }

  const getReportData3 = async() => {
    if (Cookies.get('cp-cn') !== 'GTMS-CP') {
      const response = await getDynamicSelectData({
        selectValues: '"Carrier","Group","Type", "Currency", "Net Charge","Number of Packages","Average Cost","Total Weight","Average Weight","Cost Per Pound","% of Spend","Average Zone","Gross Charge","Average Gross Rate","Average Discount","Zero Charge Package Count","Average Cost Including Zeros"', 
        tableName: 'REPORT.SERVICE_LEVEL_SPEND',
        whereField: ["Customer"], 
        whereOperators:["="], 
        whereValue: [Cookies.get('cp-cn')], 
        db: 'SF'
      });
      setReportData3({data: response})
    }
    if (Cookies.get('cp-cn') === 'GTMS-CP') {
      const response = await Axios.get(config.url.GET_REPORT, {
      params: {
        reportName: "servicelevel_spend",
        companyName: Cookies.get("cp-cn"),
      },
    });
      setReportData3({data: response.data.report})
    };
  }

  useEffect(() => { 
    getReportData();
    getReportData2();
    getReportData3();
   }, []);

  return (
    <div className='laneviewTrendsPage'> 
      <div className="LandingPageContainer">
        <NavBar/>
        <Sidebar/>
        <div className="laneviewTrendsPageContent2">
          <div className="laneviewTrendsTop">
            <div className="laneviewTrendsTitle">
              <h1>Service Level</h1>
            </div>
          </div>
          <div className="laneviewTrendsMid2">
            <div className="reportSpaced2">
              <div className="report2">
                <DynamicTable dataObject={reportData2} defaultSize='small'/>
              </div>
              <div className="report2">
                <DynamicTable dataObject={reportData} defaultSize='small'/>
              </div>
            </div>
            <div className="report2Spaced2">
              <div className="report2">
                <DynamicTable dataObject={reportData3}/>
              </div>
            </div>
          </div>
          <div className="laneviewTrendsBottom"></div>
        </div>
      </div>
    </div>
  )
}

export default ServiceLevel